import React from 'react';
import PropTypes from 'prop-types';
import {
  PiCheckCircleFill,
  PiInfoFill,
  PiWarningCircleFill,
  PiX,
} from 'react-icons/pi';
import './styles.css';

const ICONS = {
  success: PiCheckCircleFill,
  error: PiWarningCircleFill,
  info: PiInfoFill,
};

const FeedbackToast = ({
  type,
  title,
  message,
  closing,
  onClose,
}) => {
  const Icon = ICONS[type] || PiInfoFill;

  return (
    <div
      className={`
        nf-feedback-toast
        nf-feedback-toast--${type}
        ${closing ? 'nf-feedback-toast--closing' : ''}
      `.trim()}
      role={type === 'error' ? 'alert' : 'status'}
      aria-live={type === 'error' ? 'assertive' : 'polite'}
    >
      <span
        className="nf-feedback-toast__icon"
        aria-hidden="true"
      >
        <Icon />
      </span>

      <div className="nf-feedback-toast__content">
        <strong>{title}</strong>

        {message && <p>{message}</p>}
      </div>

      <button
        type="button"
        className="nf-feedback-toast__close"
        onClick={onClose}
        aria-label="Fechar notificação"
      >
        <PiX aria-hidden="true" />
      </button>
    </div>
  );
};

FeedbackToast.propTypes = {
  type: PropTypes.oneOf([
    'success',
    'error',
    'info',
  ]).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  closing: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default FeedbackToast;